import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a64ea5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "weeek-statuses__block" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "weeek-statuses__status" }, " Complete, ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "weeek-statuses__status" }, "Completed", -1))

import { GetAttributeOptionsResponseItem, WeeekDataModel } from "@/models";
import { PropType, watch } from "vue";
import WeeekStatusesItem from "./weeek-statuses-item.vue";
import { TirPmPlate } from "tir-components";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'weeek-statuses',
  props: {
  /**Данные weeek */
  dataWeeek: { type: Object as PropType<WeeekDataModel> },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TirPmPlate), { isShow: "" }, {
      titleSlot: _withCtx(() => [
        _createTextVNode("Как это работает")
      ]),
      text: _withCtx(() => [
        _createTextVNode("Статусы, предустановленные в Weeek по умолчанию, должны быть указаны слева на английском языке: "),
        _hoisted_2,
        _hoisted_3
      ]),
      _: 1
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dataWeeek.StatusesWeeek, (statusDataWeeek, index) => {
      return (_openBlock(), _createBlock(WeeekStatusesItem, {
        key: statusDataWeeek.Id,
        index: index,
        statusesDataWeeek: __props.dataWeeek.StatusesWeeek,
        statusDataWeeek: statusDataWeeek
      }, null, 8, ["index", "statusesDataWeeek", "statusDataWeeek"]))
    }), 128))
  ]))
}
}

})